import { useState } from "react";

export const Container = ({ children, nobreak }) => {
	return (
		<div
			className={`app-card d-flex flex-column m-4${
				nobreak ? "" : " col-xl-6"
			}`}
		>
			{children}
		</div>
	);
};

export const ContainerHeader = ({ children }) => (
	<div className="app-card-header">{children}</div>
);

export const ContainerBody = ({ children }) => (
	<div className="app-card-body">{children}</div>
);

const Switch = ({ setShow }) => (
	<div className="form-check form-switch">
		<input
			className="form-check-input"
			type="checkbox"
			role="switch"
			id="flexSwitchCheckDefault"
			onClick={() => setShow((p) => !p)}
		/>
	</div>
);

export const ContainerWithSwitchHeader = ({
	headerText,
	initialShow = true,
	nobreak,
	children,
}) => {
	const [show, setShow] = useState(initialShow);
	return (
		<div
			className={`app-card d-flex flex-column m-4${
				nobreak ? "" : " col-xl-6"
			}`}
		>
			<ContainerHeader>
				{headerText}
				<Switch setShow={setShow} />
			</ContainerHeader>
			{show && children}
		</div>
	);
};
